oyc.Tabs = {
  container: '.tabs',
  content: '.details-content',
  isActive: false,
  keyboardNavigationTimer: null,
  init: function () {
    this.container = $(this.container);

    if (this.container.length > 0) {
      this.toggleTabs();

      $(window).on('resize', function () {
        clearTimeout(window.resizeTimer);
        window.resizeTimer = setTimeout(function () {
          oyc.Tabs.toggleTabs();
        }, 250);
      });
    }
  },
  toggleTabs: function () {
    if (window.innerWidth >= 1024) {
      if (!this.isActive) {
        this.activateTabs();
        this.transformToTabsLayout();
        this.isActive = true;
      }
    } else {
      if (this.isActive) {
        this.deactivateTabs();
        this.isActive = false;
      }
      this.restoreOriginalMarkup();
    }
  },

  transformToTabsLayout: function () {
    // Only transform if not already transformed
    if (this.container.data('tabs-layout') === true) return;
    this.container.data('tabs-original', this.container.html());
    this.container.data('tabs-layout', true);
    this.container.each(function () {
      var $tabs = $(this);
      var $details = $tabs.find('details');
      if ($details.length === 0) return;
      var $graphic = $tabs.children('.is-graphic').detach();
      var $nav = $('<ul class="tabs-nav" role="tablist"></ul>');
      var $content = $('<div class="tabs-content"></div>');
      $details.each(function (i) {
        var $d = $(this);
        var summary = $d.find('summary').first().text();
        var id = $d.attr('id') || 'tab-' + i;
        var panelId = 'tabpanel-' + i;

        if (!$d.attr('id')) $d.attr('id', id);
        var $detailsContent = $('<div class="details"></div>');
        $detailsContent.attr({
          'id': panelId,
          'role': 'tabpanel',
          'aria-labelledby': id,
          'tabindex': '0'
        });
        $detailsContent.append($d.children().not('summary').clone(true, true));

        var isActive = $d.is('[open]') || i === 0;

        if (isActive) {
          $detailsContent.addClass('is-active');
        } else {
          $detailsContent.attr('hidden', 'hidden');
        }
        $content.append($detailsContent);

        var $li = $('<li role="presentation"></li>');
        var $button = $('<button type="button"></button>');
        $button.attr({
          'role': 'tab',
          'id': id,
          'aria-controls': panelId,
          'aria-selected': isActive ? 'true' : 'false',
          'tabindex': isActive ? '0' : '-1'
        });
        $button.text(summary);

        if (isActive) {
          $button.addClass('is-active');
        }

        $li.append($button);
        $nav.append($li);
      });
      $tabs.empty().append($graphic).append($nav).append($content);

      $tabs.find('.tabs-nav button').on('click', function () {
        oyc.Tabs.activateTab($(this), $tabs);
      });

      $tabs.find('.tabs-nav button').on('keydown', function (e) {
        oyc.Tabs.handleKeyboardNavigation(e, $tabs);
      });
    });
  },

  activateTab: function ($button, $tabs) {
    var panelId = $button.attr('aria-controls');

    $tabs.find('.tabs-nav button').removeClass('is-active')
      .attr({
        'aria-selected': 'false',
        'tabindex': '-1'
      });

    $button.addClass('is-active')
      .attr({
        'aria-selected': 'true',
        'tabindex': '0'
      });

    $tabs.find('.details').removeClass('is-active')
      .attr('hidden', 'hidden');

    var $activatedDetails = $tabs.find('.details#' + panelId)
      .addClass('is-active')
      .removeAttr('hidden');

    $tabs.find('.details').css('margin-top', '');

    var top = $button.position().top;
    var header = $('#site-header').outerHeight() || 0;
    var pageNav = $('.page-nav').outerHeight() || 0;
    $activatedDetails.css('margin-top', top + 'px');

    $('html, body').animate({
      scrollTop: $activatedDetails.offset().top - header - pageNav
    }, 500);
  },

  handleKeyboardNavigation: function (e, $tabs) {
    var $current = $(e.currentTarget);
    var $buttons = $tabs.find('.tabs-nav button');
    var currentIndex = $buttons.index($current);
    var $target = null;

    switch (e.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        $target = currentIndex > 0 ? $buttons.eq(currentIndex - 1) : $buttons.last();
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        $target = currentIndex < $buttons.length - 1 ? $buttons.eq(currentIndex + 1) : $buttons.first();
        break;

      case 'Home':
        e.preventDefault();
        $target = $buttons.first();
        break;

      case 'End':
        e.preventDefault();
        $target = $buttons.last();
        break;
    }

    if ($target) {
      $target.focus();

      clearTimeout(oyc.Tabs.keyboardNavigationTimer);

      oyc.Tabs.keyboardNavigationTimer = setTimeout(function() {
        oyc.Tabs.activateTab($target, $tabs);
      }, 300);
    }
  },

  restoreOriginalMarkup: function () {
    if (this.container.data('tabs-layout') === true) {
      var original = this.container.data('tabs-original');
      if (original) {
        this.container.html(original);
        this.container.data('tabs-layout', false);
        this.container.removeData('tabs-original');
      }
    }
  },
  activateTabs: function () {
    this.container.on('click', 'details', function (e) {
      if ($(this).attr('open') !== undefined) {
        return;
      }

      $(this).closest('.tabs').find('details').removeAttr('open');
      $(this).attr('open', true);
    });

    this.openFirstIfNoneOpened();
  },
  deactivateTabs: function () {
    this.container.off('click', 'details');
    $(window).off('load.tabs');
    this.container.find('details').removeAttr('open');
    clearTimeout(this.keyboardNavigationTimer);
  },
  openFirstIfNoneOpened: function () {
    this.container.each(function () {
      var openedDetails = $(this).find('details[open]');
      if (openedDetails.length === 0) {
        var firstDetails = $(this).find('details').first();
        firstDetails.attr('open', true);
      }
    });
  }
};
